<template>
  <v-card :key="mode">
    <!-- navigation tabs -->
    <v-card class="d-flex justify-center align-center">
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="mode !== 'new' ? true : false">Persona</v-tab>
          <v-tab :disabled="!object">Usuario</v-tab>
        </v-tabs>
      </div>
    </v-card>

    <!-- person search only for new registers -->
    <person
      v-if="currentTab === 0 && mode === 'new'"
      @itemSelected="personSelected($event)"
      :enableManual="true"
    ></person>

    <!-- commercialPerson data -->
    <v-card-text v-if="currentTab === 1 && object">
      <v-card>
        <v-card class="mb-2">
          <v-card-title>
            Persona
          </v-card-title>
          <v-card-text>
            <v-text-field
              disabled
              label="Nombre"
              id="person_name"
              v-model="object.person_name"
            ></v-text-field>
            <v-text-field
              disabled
              label="Tipo Identificación"
              id="person_identification_type_description"
              v-model="object.person_identification_type_description"
            ></v-text-field>
            <v-text-field
              disabled
              label="Identificación"
              id="person_identification"
              v-model="object.person_identification"
            ></v-text-field>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title>
            Usuario
          </v-card-title>
          <v-card-text>
            <!-- commercial -->
            <div class="d-flex align-center">
              <v-text-field
                disabled
                :value="
                  object.commercial_person
                    ? object.commercial_person_type_description +
                      ' - ' +
                      object.commercial_person_name
                    : null
                "
                label="Comercial a Impersonar"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  v-show="editing"
                  @click="commercialPersonClick"
                >
                  {{
                    !object.commercial_person
                      ? "mdi-magnify"
                      : "mdi-trash-can-outline"
                  }}
                </v-icon>
              </v-text-field>
            </div>
            <v-text-field
              label="email"
              id="email"
              v-model="object.email"
              :disabled="!editing"
              @input="
                v => {
                  object.email = v.toLowerCase();
                }
              "
            ></v-text-field>
            <!-- Habilitado -->
            <v-switch
              :disabled="!editing"
              v-model="object.can_authenticate"
              inset
              label="Habilitado para uso del sistema"
            ></v-switch>
          </v-card-text>
        </v-card>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showCommercialPerson"
      :show="showCommercialPerson"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordeting"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="commercialPersonSelected($event)"
      @cancel="commercialPersonCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import Person from "@/components/Person.vue";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "CommercialPersonAliasEdit",

  components: {
    Person,
    PaginatedSearchDialog
  },

  props: ["value", "initialmode"],

  data: () => ({
    currentTab: 0,
    current_level: null,
    editing: false,
    mode: null,
    object: null,
    showCommercialPerson: false,
    searchOptions: {}
  }),

  methods: {
    async personSelected(person) {
      try {
        if (!person.identification_type_code) {
          person = await this.$bRoot.getObjectByURL(person.url);
        }
        //tryNew
        let response = await this.$bRoot.search(
          "/data/extended_commercial_persons_alias",
          null,
          null,
          "person__identification_type__code=" +
            person.identification_type_code +
            "&person__identification=" +
            person.identification
        );
        if (response.data.results.length > 0) {
          // edit commercial_alias
          this.mode = "edit";
          this.beginEdit(response.data.results[0].url);
        } else {
          // new commercial
          this.mode = "new";
          this.initialize(person);
          this.currentTab = 1;
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    async beginEdit(commercial_person_alias_url) {
      try {
        let cpa = await this.$bRoot.getObjectByURL(commercial_person_alias_url);
        if (cpa) {
          this.object = cpa;
          // eslint-disable-next-line
          if (this.mode === "edit" && ((cpa.user_id ? cpa.user_id : -1) === this.$bRoot.appInfo.user_id)) {
            this.mode = "show";
          }
          this.editing = this.mode === "edit" || this.mode == "new";
          this.currentTab = 1;
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    initialize(person) {
      this.object = {
        id: null,
        url: null,
        person: person.url,
        person_identification_type_code: person.identification_type_code,
        person_identification_type_description:
          person.identification_type_description,
        person_identification: person.identification,
        person_name: person.name,
        commercial_person: null,
        commercial_person_name: null,
        commercial_person_type_description: null,
        email: null,
        can_authenticate: false
      };
    },

    commercialPersonClick() {
      if (this.object.commercial_person) {
        //remuve commercial_person
        this.object.commercial_person = null;
        this.object.commercial_person_name = null;
        this.object.commercial_person_type_level = null;
      } else {
        //add commercial_person
        this.searchOptions = {
          headers: [
            { text: "Nombre", value: "name", sortable: false },
            {
              text: "Tipo Identificación",
              value: "identification_type_code",
              sortable: false
            },
            // eslint-disable-next-line
            { text: "Nro.Identificación", value: "identification", sortable: false },
            // eslint-disable-next-line
            { text: "Tipo", value: "commercial_type_description", sortable: false },
          ],
          title: "Impersonar Comercial",
          endpoint: "data/commercial_persons_hierarchy",
          ordering: "name",
          searchLabel: "Nombre/CUIT",
          filterString: null
        };
        this.showCommercialPerson = true;
      }
    },

    commercialPersonSelected(data) {
      this.showCommercialPerson = false;
      this.searchOptions = {};
      this.object.commercial_person = data.commercial_person;
      this.object.commercial_person_name = data.name;
      this.object.commercial_person_type_description =
        data.commercial_type_description;
    },

    commercialPersonCanceled() {
      this.showCommercialPerson = false;
      this.searchOptions = {};
    },

    async save() {
      try {
        //validate commercial_person information
        if (this.$bRoot.isNullOrEmpty(this.object, "person")) {
          throw "El dato persona es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(this.object, "commercial_person")) {
          throw "El dato comercial a impersonar es obligatorio";
        }
        let object = {
          person: this.object.person,
          email: this.object.email,
          can_authenticate: this.object.can_authenticate,
          commercial_person: this.object.commercial_person
        };
        if (this.object.url) {
          object.url = this.object.url;
        }
        if (this.object.user) {
          object.user = this.object.user;
        }
        let added = null;
        if (object.url) {
          added = await this.$bRoot.save(object);
        } else {
          added = await this.$bRoot.add(
            "/data/extended_commercial_persons_alias",
            "person__identification_type__code=" +
              this.object.person_identification_type_code +
              "&person__identification=" +
              this.object.person_identification,
            object
          );
        }
        if (added) {
          this.$emit("endEdit");
        } else {
          throw "El registro no se guardo";
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
          return null;
        }
      }
    }
  },

  async mounted() {
    this.currentTab = this.value ? 1 : 0;
    this.mode = this.initialmode;
    this.current_level = this.$bRoot.auth.current_level;
    if (this.value) {
      await this.beginEdit(this.value);
    }
    this.editing = this.mode === "edit" || this.mode == "new";
  },

  watch: {
    mode: {
      handler() {
        this.$emit("modeChange", this.mode);
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
